import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Select, SelectProps } from '@mantine/core';

import { BatchFormType } from 'store/batches/types';

type BatchCarouselSelectPropsType = Omit<SelectProps, 'onChange' | 'data' | 'value' | 'label'> & {
  batch: BatchFormType;
  onValueChange: (attributeKey: keyof BatchFormType, newValue: number) => void;
  showLabel?: boolean;
};

export const BatchCarouselSelect = ({
  batch,
  onValueChange,
  showLabel,
  ...props
}: BatchCarouselSelectPropsType) => {
  const { t } = useTranslation();
  const carouselOptions = Array.from({ length: 100 }, (_, i) => ({
    value: String(i + 1),
    label: String(i + 1),
  }));

  const handleOnChange = (value: string | null) => {
    if (value) {
      onValueChange('carousel', parseInt(value, 10));
    }
  };

  useEffect(() => {
    if (!batch.carousel) {
      handleOnChange(carouselOptions[0].value);
    }
  }, [batch, carouselOptions]);

  return (
    <Select
      onChange={handleOnChange}
      data={carouselOptions}
      value={String(batch.carousel)}
      label={showLabel && t('carousel')}
      searchable
      {...props}
    />
  );
};
